import { URL_SEARCH_PARAMS } from "repoV2/constants/urls&routing/urlParams";
import { getQueryParam } from "repoV2/utils/urls&routing/urlParams";

/**
 * Checks whether the current offering supports direct booking i.e., if user details form is skippable
 * The check is based on the presence of query parameters for live session booking or community bonus offering.
 *
 * @returns {boolean} True if the offering supports direct booking, false otherwise.
 */
export const getIsOfferingSupportsDirectBooking = () => {
    const isLiveSessionBookingOffering = getQueryParam(
        URL_SEARCH_PARAMS.LIVE_SESSION_BOOKING
    );
    const isCommunityBonusOffering = getQueryParam(
        URL_SEARCH_PARAMS.COMMUNITY_ID
    );
    // this to use in creator app registation flow
    const isCreatorAppRegistration = getQueryParam(
        URL_SEARCH_PARAMS.PREFILL_FORM_DATA
    );
    return (
        isLiveSessionBookingOffering ||
        isCommunityBonusOffering ||
        isCreatorAppRegistration
    );
};
